export class PivotPoint extends THREE.Group {
    constructor(pickingData, modelId) {
        super();

        this.model = getModelObject(modelId);
        this.point = pickingData.point;
        this.branchID = pickingData.volume.branchID;

        this.model.addEventListener('modelMoved', this.updateModel.bind(this));
        this.model.addEventListener('volumeMoved', this.updateVolume.bind(this));

        this.cameraEventCallback = (configuration) => this.updateWithCamera(configuration);
        iq3Camera.addEventListener('change', this.cameraEventCallback);

        this.size = new THREE.Vector3();
        if (this.model.isPointCloudModel) {
            pickingData.object.boundingBox.getSize(this.size);
        } else {
            this.model.geometry.boundingBox.getSize(this.size);
        }
        this.size = this.size.length() * 0.001;

        this.createPointObject();
    }

    updatePoint(offsetMatrix = new THREE.Matrix4()) {
        this.point.applyMatrix4(offsetMatrix);
        this.pointObject.position.copy(this.point);
    }

    updateModel(event) {
        let offsetMatrix = event.matrixWorldAfter.clone().multiply(event.matrixWorldBefore.clone().invert());
        this.updatePoint(offsetMatrix);
    }

    updateVolume(event) {
        if (this.branchID !== event.branchId) {
            return;
        }

        this.updateModel(event);
    }

    updateWithCamera(configuration) {
        const pointPosition = this.pointObject.position.clone();
        const scale = 1.75 * Math.min(wv.maxDistanceForTooltipScalling, pointPosition.distanceTo(configuration.position)) * CurveWidthToObserverDistanceRatio;
        this.pointObject.scale.set(scale, scale, scale);
    }

    createPointObject() {
        this.pointObject = BasicShapes.sphere;

        this.pointObject.position.copy(this.point);

        this.add(this.pointObject);

        this.updateWithCamera(iq3Camera.getConfigurationWorld());

        return this.pointObject;
    }

    getPivot() {
        return {
            pivot: getOrgPosition(this.model.worldToLocal(this.point.clone()), this.model.modelId, this.branchID)
        };
    }

    destroy() {
        if (this.parent) {
            this.parent.remove(this);
        }

        iq3Camera.removeEventListener('change', this.cameraEventCallback);

        disposeObject(this);
    }
}
